import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import DeleteServiceProviderFormModal from 'src/features/serviceProvider/components/form/DeleteServiceProviderFormModal';
import UpdateServiceProviderFormModal from 'src/features/serviceProvider/components/form/UpdateServiceProviderFormModal';
import { organisationMessages } from 'src/features/serviceProvider/utils/messages';
import { ServiceProvider } from 'src/features/serviceProvider/utils/types';
import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

export default function CellServiceProviderActions({ row }: CellContext<ServiceProvider, unknown>) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateServiceProviderFormModal
                        semantics={{ entryName: formatMessage(organisationMessages.organisation).toLowerCase() }}
                        selectedServiceProvider={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateServiceProviderFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteServiceProviderFormModal
                        selectedServiceProvider={row.original}
                        semantics={{ entryName: formatMessage(organisationMessages.organisation).toLowerCase() }}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteServiceProviderFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
